import Swiper from "../../../../../assets/vendor/swiper/swiper-bundle.esm.browser";

export default class GallerySlider {
    /**
     * Cosstructor
     * @param $slider
     */
    constructor($slider) {
        this.$slider = $slider;

        this.slider = (new Swiper(this.$slider, {
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: '.elementor-swiper-button-next',
                prevEl: '.elementor-swiper-button-prev',
            },
            breakpoints: {
                600: {
                    slidesPerView: 2,
                },
                900: {
                    slidesPerView: 3,
                }
            }
        }))
    }
}